import Button from 'components/Button';
import { useRef, FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { border1 } from 'utils/style/colors';
import ImageCropper from './ImageCropper';

const VideoContentContainer = styled.div`
  & > video {
    width: 90%;
    padding: 1rem;
    margin: 1rem auto;
    max-height: 30rem;
    border-radius: 1rem;
    border: ${border1};
  }
`;

const FrameContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  & > * {
    padding: 1rem;
  }

  @media screen and (max-width: 600px) {
    align-items: center;
  }
`;

const SelectFrameContainer = styled.div`
  width: 100%;
`;

interface IProps {
  videoUrl: string;
  onThumbnailSelected: (blob: any) => void;
  previewImage?: string;
  onSetPreview: (prev: string) => void;
}

const VideoThumbnailPicker: FC<IProps> = ({
  videoUrl,
  onThumbnailSelected,
  previewImage,
  onSetPreview,
}) => {
  const { t } = useTranslation('modals');

  const videoRef = useRef<HTMLVideoElement>(null);

  const captureFrame = () => {
    const video = videoRef.current;
    if (!video) return;

    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    canvas.toBlob(
      (blob) => {
        if (!blob) return;

        const url = URL.createObjectURL(blob);
        onSetPreview(url);

        onThumbnailSelected?.(blob);
      },
      'image/jpeg',
      0.9
    );
  };

  return (
    <VideoContentContainer>
      <video
        ref={videoRef}
        src={videoUrl}
        controls
        style={{ width: '100%', marginBottom: 20 }}
        crossOrigin="anonymous" // important if CDN requires it
      />
      <FrameContainer>
        <SelectFrameContainer>
          <Button onClick={captureFrame} color="black-outline">
            {t('captureFrame')}
          </Button>
        </SelectFrameContainer>
        {/* <ThumbnailPreviewContainer>
          <h4 className="font-bold">{t('selectedFrame')}</h4>
          {previewUrl && <img src={previewUrl} />}
        </ThumbnailPreviewContainer> */}

        {previewImage && (
          <ImageCropper
            imageSrc={previewImage}
            aspectRatio={1}
            onCropped={onThumbnailSelected}
            onSetPreview={onSetPreview}
          />
        )}
      </FrameContainer>
    </VideoContentContainer>
  );
};

export default VideoThumbnailPicker;
